import { NevisPasskeysSwissInfoValues } from './types';

export const MONTHS = [
    'playtech.mobile.system.month.January',
    'playtech.mobile.system.month.February',
    'playtech.mobile.system.month.March',
    'playtech.mobile.system.month.April',
    'playtech.mobile.system.month.May',
    'playtech.mobile.system.month.June',
    'playtech.mobile.system.month.July',
    'playtech.mobile.system.month.August',
    'playtech.mobile.system.month.September',
    'playtech.mobile.system.month.October',
    'playtech.mobile.system.month.November',
    'playtech.mobile.system.month.December'
];

export const NEVIS_PASSKEYS_SWISS = 'nevis-passkeys-swiss';

export const CREATE_PASSKEYS_BUTTON = 'playtech.mobile.nevis-passkeys-swiss.noPasskeys.addPasskey.btn';

export const PASSKEYS_MOBILE_INFO: NevisPasskeysSwissInfoValues = ['definition', 'saving'];

export const PASSKEYS_ACTIONS: NevisPasskeysSwissInfoValues = ['rename', 'revoke'];

export const PASSKEYS_DESKTOP_INFO: NevisPasskeysSwissInfoValues = ['desktop.definition', 'desktop.device', 'desktop.saving'];
